import { Icon } from "@iconify/react";

export const downloads = [
  {
    description: "Data summarized by country",
    url: "https://s3-west.nrp-nautilus.io/vizlab-geodatalake-exports/downloads/ucsc_cwon_countrybounds.gpkg",
    icon: (
      <Icon icon="material-symbols:download" height="1.1em" width="1.1em" />
    ),
    download: true,
  },
  {
    description: "Data summarized by coastal study units (~20km)",
    url: "https://s3-west.nrp-nautilus.io/vizlab-geodatalake-exports/downloads/ucsc_cwon_studyunits.gpkg",
    icon: (
      <Icon icon="material-symbols:download" height="1.1em" width="1.1em" />
    ),
    download: true,
  },
];

export default downloads;
